export var getGalllleryUrl = function (isShop) {
    var _a;
    var galleryUrls = {
        develop: 'https://gallllery-com.burgdev.ru',
        staging: 'https://gallllery-com.burgstg.ru',
        production: 'https://gallllery.com',
        hseOnline: 'https://gallllery.com'
    };
    var shopGalleryUrls = {
        develop: 'https://artz-work.burgdev.ru',
        staging: 'https://artz-work.burgstg.ru',
        production: 'https://artz.work',
        hseOnline: 'https://artz.work'
    };
    return (isShop ? shopGalleryUrls : galleryUrls)[(_a = process.env.REACT_APP_API_CONNECTION_MODE) !== null && _a !== void 0 ? _a : 'develop'];
};
//# sourceMappingURL=getGalllleryUrl.js.mapexport var getGalllleryUrl = function (isShop) {
    var _a;
    var galleryUrls = {
        develop: 'https://gallllery-com.burgdev.ru',
        staging: 'https://gallllery-com.burgstg.ru',
        production: 'https://gallllery.com',
        hseOnline: 'https://gallllery.com'
    };
    var shopGalleryUrls = {
        develop: 'https://artz-work.burgdev.ru',
        staging: 'https://artz-work.burgstg.ru',
        production: 'https://artz.work',
        hseOnline: 'https://artz.work'
    };
    return (isShop ? shopGalleryUrls : galleryUrls)[(_a = process.env.REACT_APP_API_CONNECTION_MODE) !== null && _a !== void 0 ? _a : 'develop'];
};
//# sourceMappingURL=getGalllleryUrl.js.map